// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-container[data-v-8e8c3f54] {\n  margin-top: -20px;\n  margin-bottom: -20px;\n}\n.account-container[data-v-8e8c3f54] .el-form--label-top .el-form-item__label {\n  padding-bottom: 4px;\n}\n.account-container[data-v-8e8c3f54] .el-form-item {\n  margin-bottom: 8px;\n}\n.account-container[data-v-8e8c3f54] .hotel-select .el-select__placeholder {\n  color: #606266 !important;\n  opacity: 1 !important;\n}", ""]);
// Exports
module.exports = exports;
